export default function Services() {
  const services = [
    {
      icon: 'ri-user-heart-line',
      title: 'Individual Therapy',
      description: 'One-on-one sessions tailored to your unique needs. We address anxiety, depression, trauma, stress management, and personal growth through evidence-based therapeutic approaches.',
      bgColor: 'bg-[#FFE5E5]',
      accentColor: 'text-[#D97777]',
      height: 'h-[420px]'
    },
    {
      icon: 'ri-parent-line',
      title: 'Family Therapy',
      description: 'Strengthen family bonds and improve communication. Our family therapy sessions help resolve conflicts, rebuild trust, and create healthier dynamics for every member of the household.',
      bgColor: 'bg-[#E5F0ED]',
      accentColor: 'text-[#5A8F7B]',
      height: 'h-[420px]'
    },
    {
      icon: 'ri-team-line',
      title: 'Group Sessions',
      description: 'Find support and healing in a community setting. Our group therapy sessions provide a safe space for shared experiences, mutual support, and collective growth.',
      bgColor: 'bg-[#F0EDF6]',
      accentColor: 'text-[#8B7BA8]',
      height: 'h-[420px]'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#2C5F7C] text-sm font-semibold tracking-wider uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
            Our Services
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Therapeutic Approaches
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            We offer comprehensive mental health services designed to support your journey toward emotional wellness and personal growth.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bgColor} ${service.height} rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-pointer`}
            >
              <div className={`w-16 h-16 flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-5xl ${service.accentColor}`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                {service.title}
              </h3>
              <p className="text-gray-700 text-base leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
